import { render, staticRenderFns } from "./TaskTab.vue?vue&type=template&id=110f335f&scoped=true&"
import script from "./TaskTab.vue?vue&type=script&lang=js&"
export * from "./TaskTab.vue?vue&type=script&lang=js&"
import style0 from "./TaskTab.vue?vue&type=style&index=0&id=110f335f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110f335f",
  null
  
)

export default component.exports